/* SolNow — rutas de la ticketera nativa. Sin featureFlag ni installationTypes:
   la feature del fork está siempre disponible (incl. self-hosted community).
   El tablero (Board) es la vista por defecto. */
import { frontendURL } from '../../../helper/URLHelper';
import TicketsBoard from './pages/TicketsBoard.vue';
import TicketsList from './pages/TicketsList.vue';

const commonMeta = {
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/tickets'),
    name: 'tickets_dashboard_index',
    component: TicketsBoard,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/tickets/list'),
    name: 'tickets_dashboard_list',
    component: TicketsList,
    meta: commonMeta,
  },
];
